<template>
  <div>
    <div>
      <div class="settings-row" style="padding: 5px auto; margin-bottom: 0 !important; margin-top: 0 !important; background-color: #F7F7F7;">
        <i class="mdi mdi-voicemail" aria-hidden="true"></i>&nbsp;{{ $t('voicemails.voicemail') }}
      </div>
    </div>
    <div class="history-row" style="padding: 5px auto; margin-bottom: 0 !important; margin-top: 0 !important;">
      <b-input-group>
        <b-input-group-prepend>
          <span class="input-group-text" style="padding: .1rem .75rem !important;"><i class="mdi mdi-magnify" aria-hidden="true"></i></span>
        </b-input-group-prepend>
        <b-form-input style="border-right: 0;" v-model="search" @keyup="performSearch" size="sm" :placeholder="$t('voicemails.search')">
        </b-form-input>
        <b-input-group-append v-if="search.length > 0">
          <span class="input-group-text" style="padding: .1rem 0 !important; cursor: pointer; background-color: transparent; border-left: 0;" @click="clearSearch"><i class="mdi mdi-close" aria-hidden="true"></i></span>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div style="height: 497px; width: 240px; overflow-y: scroll; padding: 0 20px; text-align: center; background-color: #FFFFFF;" v-if="loading">
      <div class="text-center">
        <span><b-spinner variant="teal" small></b-spinner>&nbsp;Loading...</span>
      </div>
    </div>
    <div style="height: 497px; width: 240px; overflow-y: scroll; padding: 0 20px; text-align: center; background-color: #FFFFFF;" v-else>
      <div v-if="voicemailbox_present && messages.length > 0">
        <div class="history-row" v-for="(m, i) in sortedMessages.slice().reverse()" :key="`messages${i}`">
          <p v-if="i === 0" class="link text-teal" @click="callVoicemail">{{ $t('voicemails.click') }}</p>
          <span v-if="m.status === 'New'"><i class="mdi mdi-alert-decagram" style="color: #009AB1; cursor: pointer;" aria-hidden="true"></i>&nbsp;</span>
          <span><text-highlight :queries="queries" :highlightStyle="highlightStyle">{{ m.caller_id }} {{ m.caller_name && m.caller_name.length > 0 && m.caller_name !== m.caller_id ? `(${m.caller_name})` : '' }}</text-highlight></span>
          <br />{{ m.created_at | formatTime(today, yesterday, ' ') }}
          &nbsp;&nbsp;<i class="mdi mdi-check" style="color: #009AB1; cursor: pointer;" v-tooltip="$t('voicemails.markNew')" aria-hidden="true" @click="markVoicemailNew(m.url)" v-if="m.status !== 'New'"></i>
          <i class="mdi mdi-check" style="cursor: pointer;" v-tooltip="$t('voicemails.markRead')" aria-hidden="true" @click="markVoicemailRead(m.url)" v-else></i>
          &nbsp;<i class="mdi mdi-delete" style="color: red; cursor: pointer;" v-tooltip="$t('voicemails.remove')" @click="markVoicemailDelete(m.url)" aria-hidden="true"></i>
          <br />
          <audio style="width: 210px;"
            controls
            :src="m.url"
            type="audio/wav"
            @play="markVoicemailRead(m.url, true)"
          >
          </audio>
        </div>
      </div>
      <div v-else-if="voicemailbox_present && messages.length === 0">
        {{ $t('voicemails.zeroFound') }}
      </div>
      <div v-else>
        {{ $t('voicemails.notConfigured', { appName: $whitelabel.getAppName() }) }}
        <br /><br /><br /><br />
        <span class="link text-teal" @click="callVoicemail">{{ $t('voicemails.click') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import TextHighlight from 'vue-text-highlight';

export default {
  name: 'Voicemails',
  components: {
    'text-highlight': TextHighlight
  },
  mounted: async function () {
    var self = this
    self.sortedMessages = self.messages

    var today = new Date().toLocaleString("en-US", {timeZone: "America/New_York"})
    today = today.split(',')[0]

    self.today = `${today.split('/')[1].length === 1 ? '0' + today.split('/')[1] : today.split('/')[1]} ${today.split('/')[0].length === 1 ? '0' + today.split('/')[0] : today.split('/')[0]} ${today.split('/')[2]}`

    today = new Date()
    var yesterday = new Date(today)
    yesterday.setDate(today.getDate() - 1)
    yesterday = yesterday.toLocaleString("en-US", {timeZone: "America/New_York"})
    yesterday = yesterday.split(',')[0]

    self.yesterday = `${yesterday.split('/')[1].length === 1 ? '0' + yesterday.split('/')[1] : yesterday.split('/')[1]} ${yesterday.split('/')[0].length === 1 ? '0' + yesterday.split('/')[0] : yesterday.split('/')[0]} ${yesterday.split('/')[2]}`
  },
  props: {
    windowWidth: {
      type: Number
    },
    voicemail_id: {
      type: String
    },
    messages: {
      type: Array
    },
    voicemailbox_present: {
      type: Boolean
    },
    loadVoicemailMessages: {
      type: Function
    },
    markVoicemailNew: {
      type: Function
    },
    markVoicemailRead: {
      type: Function
    },
    markVoicemailDelete: {
      type: Function
    },
    callVoicemail: {
      type: Function
    }
  },
  data () {
    return {
      today: null,
      yesterday: null,
      sortedMessages: [],
      search: '',
      queries: [],
      highlightStyle: { 'background-color': 'white', color: '#167bff', 'font-size': '1.15rem' },
      loading: false
    }
  },
  methods: {
    performSearch () {
      var self = this
      if (self.search.length <= 0) {
        self.sortedMessages = self.messages
        self.queries = []
      } else {
        var tempMessages = []
        self.queries = []

        self.messages.forEach ((m) => {
          if (m.caller_id.toLowerCase().indexOf(self.search.toLowerCase()) != -1) {
            tempMessages.push(m)
          }
        })

        self.sortedMessages = tempMessages
        self.queries.push(self.search)
      }
    },
    clearSearch () {
      var self = this
      self.sortedMessages = self.messages
      self.queries = []
      self.search = ''
    },
    reloadData (messages) {
      var self = this
      if (self.search.length <= 0) {
        self.sortedMessages = messages
        self.queries = []
      } else {
        var tempMessages = []
        self.queries = []

        messages.forEach ((m) => {
          if (m.caller_id.toLowerCase().indexOf(self.search.toLowerCase()) != -1) {
            tempMessages.push(m)
          }
        })

        self.sortedMessages = tempMessages
        self.queries.push(self.search)
      }
    }
  }
}

</script>

<style lang="scss">
.settings-row {
  margin: 20px auto !important;
  width: auto;
  max-width: 420px !important;
  height: auto !important;
  clear: both !important;
}

.settings-sub-row {
  margin: 20px auto !important;
  width: auto;
  max-width: 420px !important;
  height: auto !important;
  clear: both !important;
  text-align: left !important;
}

.settings-sub-row-hover:hover {
  color: #009AB1 !important;
  cursor: pointer;
}

.vs__dropdown-menu {
  max-height: 200px !important;
}

.vs__dropdown-option--highlight {
  background-color: #009AB1 !important;
}

.text-teal {
  color: #009AB1;
}
</style>
